<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Payroll Report </strong>

          </div>
 
    <div class="p-2">
      <b-row>
        <b-col sm="4">
          <b-form-group label="Select Hub:" :label-cols="3">
            <template #label>
              <span>Select Hub:</span>
            </template>
            <b-form-select v-model="selectedhub">
              <option :value="selected">-- Select Hub --</option>
              <option :value="hub.hubid" v-for="hub in hubItems" :key="hub.hubid">
                {{ hub.hubname }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="From Date:" :label-cols="3">
            <v-date-picker 
              mode="single" 
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="selectDate">
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="To Date:" :label-cols="3">
            <v-date-picker 
              mode="single" 
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="toselectDate">
            </v-date-picker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
      <b-col md="12"  class="text-right">
  <div>
    <b-button variant="primary" @click="hubconfigurationlist()">Search</b-button>
    <a :href="loadurl" target="_blank" class="ml-2">
      <b-button variant="primary" :disabled="isdownload"  size="md" @click="downlaodloadurl">Download</b-button>

      <!-- <b-button variant="primary" size="md" @click="ExportList" :disabled="finalOutput.length == 0">
        Download Report
      </b-button> -->
    </a>
  </div>
</b-col>
</b-row>
 
<b-table show-empty responsive :busy="isBusy" :items="attendancedatarows" :fields="fields"  :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"  @filtered="onFiltered" style="overflow-x: auto !important;"> 

<div slot="table-busy" class="text-center text-danger my-2">
  <b-spinner class="align-middle">
  </b-spinner>
  <strong>Loading...</strong>
</div> 


</b-table>
 

    </div>
  
    </b-card>
  </b-col>
    </b-row>

    </div>

</template>
    
    <script>
    import CONSTANTS from "@/utils/constants";
    import Utils from "@/utils";
    import auth from "@/utils/auth";
    export default {
    //     components: {
    //     Modal
    //   },
      data() {
          return {
              selectDate : new Date(),
              toselectDate : new Date(),
              valueWH:[],
              fieldWH:{ text: 'name', value: 'id' },
              optionsWH:[],
              WHData:[],
              hubItems:[],
              selected: "",
              selectedhub:'',
              items:[],
              header:[],
              headerValues:[],
              finalOutput:[],
              totalcountflag: true,
              norecordsfound:true,
              itemsdata:[],
              currentMonthCycleFromDates:'',
              currentMonthCycleToDates:'',
              showSelectAll : true,
              loadurl:'',
              attendancedatarows:[],
              fields:[],
              isBusy:false,
              isdownload:true
          }
      },
    
      created() {
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
  
           const currentMonthCycleDates = this.getCurrentMonthCycleDates();
          this.selectDate = currentMonthCycleDates.fromDate;
       this.toselectDate = currentMonthCycleDates.toDate;
  
        this.hubconfigurationlist()
          this.hubListing();
          //this.SearchList('bydefault');
          //this.ExportList();
      },
    
      methods: {

        hubconfigurationlist : function(){     
          var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
       this.isBusy=true;
 
     //   if(this.typelist.includes(this.documenttype)){
 
  
        // this.fields=[
             
        //         { key: 'hubname', label : 'Hub Name', sortable: true},
        //         { key: 'shiftname', label : 'Shift', sortable: true},
        //         { key: 'shiftstart', label : 'Shift Start', sortable: true},
        //         { key: 'shiftend', label : 'Shift End', sortable: true},
        //         { key: 'totalshifthours', label : 'Total_Shift_Hours', sortable: true},
        //         { key: 'workinghours', label : 'Working_Hours', sortable: true},
        //         { key: 'teabreakstart', label : 'Tea Break Start', sortable: true},
        //         { key: 'teabreakend', label : 'Tea Break End', sortable: true},
        //         { key: 'lunchbreakstart', label : 'Lunch Break Start', sortable: true},
        //         { key: 'lunchbreakend', label : 'Lunch Break End', sortable: true},
        //         { key: 'totalbreak', label : 'Total Break', sortable: true},
        //     ]
        
        var selectDate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";
              var toselectDate = (this.toselectDate!=null)?this.formatDate(this.toselectDate):"";

        var Obj = {
                  sysusermasterid:`${userInfo.sysusermasterid}`,
                  startdate : selectDate,
                  enddate : toselectDate,
                  selectedhub : `${this.selectedhub}`,
                  usertype:`${userInfo.user_type}`
              }

              //console.log('s====================')

         this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/payrollreportlisting`,Obj)
        .then(result => {
            console.log("result",result)
            this.isBusy=false;
            if (result.body.returnmsg.toLowerCase() === "successful") {
                let v = result.body.returnvalue
                const keys = Object.keys(v[0]);

                const formattedKeys = keys.map(key => ({
                key: key,
                label: key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
                sortable: true
                }));

                     this.fields = formattedKeys
                    this.attendancedatarows = v
                   this.isdownload = false
              //  console.log('this.attendancedatarows===========>',this.attendancedatarows)
            }else{
                this.attendancedatarows = []
                this.isdownload = true

             }
        }).catch(ex => {
            console.log("error", ex);
        });
    //}
    },
    downlaodloadurl(){
 //  var userdata = localStorage.getItem("userData");
   //var userInfo = JSON.parse(userdata);
    var selectDate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";
              var toselectDate = (this.toselectDate!=null)?this.formatDate(this.toselectDate):"";
              this.selectedhub = this.selectedhub ? this.selectedhub : ''
   this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/payrollreportDownload?selectedhub=`+this.selectedhub+`&startdate=`+selectDate+`&enddate=`+toselectDate+` `
   console.log("this.loadurl",this.loadurl)
 },
       getCurrentMonthCycleDates() {
              const today = new Date();
              const year = today.getFullYear();
              const month = today.getMonth(); // 0 = January, 1 = February, etc.
  
              // Create "from" and "to" dates
              const fromDate = new Date(year, month-1, 26);// 1st of the current month
              const toDate = new Date(year, month, 25); // 26th of the current month
  
              return {
                  fromDate: fromDate,
                  toDate: toDate
              };
      },
  
      hubListing(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
          const obj={
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype : `${userInfo.user_type}`,
          }
  
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubList`, obj)
              .then(result => {
              
              if (result.body.returnmsg === 'Successful') {
                  this.hubItems=[];
              
                  this.WHData  = result.body.returnvalue;
                  
                  for(let j = 0; j < this.WHData.length; j++) {
                      let WH = {
                          hubname: this.WHData[j].hub_title + " - " + this.WHData[j].fcclock_hubid,
                      hubid: this.WHData[j].id,
                      }
                  this.hubItems.push(WH);
                  }
                  if(this.hubItems.length == 1)
                      {
                        this.selectedhub = this.hubItems[0].hubid;
                      }
              
              } else {              
                  this.WHData  = result.body.returnvalue;
              }
          
  
          })
          .catch(ex => {
              console.log("error-----", ex);
          });
        },
      SearchList : function (flag) {
              var userdata = localStorage.getItem("userData");
              var userInfo = JSON.parse(userdata);
  
              const attendanceBody = document.getElementById('attendanceBody');
              const presentCountHeader = document.getElementById('presentCountHeader');
              const singlePayCountHeader = document.getElementById('singlePayCountHeader');
              
              var selectDate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";
              var toselectDate = (this.toselectDate!=null)?this.formatDate(this.toselectDate):"";
  
              if(flag == 'bydefault' && this.currentMonthCycleFromDates != '')
              {
                  selectDate = this.formatDate(this.currentMonthCycleFromDates);
                  this.selectDate = selectDate;
              }
  
              if(flag == 'bydefault' && this.currentMonthCycleToDates != '')
              {
                  toselectDate = this.formatDate(this.currentMonthCycleToDates);
                  this.toselectDate = toselectDate;
              }            
              const csvObj = {
                  sysusermasterid:`${userInfo.sysusermasterid}`,
                  startdate : selectDate,
                  enddate : toselectDate,
                  selectedhub : `${this.selectedhub}`,
                  usertype:`${userInfo.user_type}`
              }
              this.itemsdata  = [];
  
              
              
              
            
              // const attendanceBody = document.getElementById('attendanceBody');
              this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubWiseEmployeeReport`,csvObj)
                .then(result =>{
                  const attendanceBodyda = document.getElementById('attendanceBody');
                  if(attendanceBodyda)
                  {
                      while (attendanceBodyda.firstChild) {
                      attendanceBodyda.removeChild(attendanceBodyda.firstChild);
                  }
      
                  const noRecordsRow = document.createElement('tr');
                  noRecordsRow.innerHTML = ''; // Adjust colspan based on your table
                  attendanceBodyda.appendChild(noRecordsRow);
      
                  }
                  this.itemsdata = result.body.resultda;
                  console.log("result.body--------->",this.itemsdata);
  
                  console.log("this.selectedhub------->",this.selectedhub);
                  console.log("this.hubItems.length------->",this.hubItems.length);
                 
                    if(result.body.msg == "1" && this.hubItems.length != 1 )
                        {
  
                                 this.totalcountflag = false;
                              
                                  const dateColumns = this.generateDateRangeColumns(selectDate, toselectDate);
                                  const formatedateColumns = this.generateDateFormateRangeColumns(selectDate, toselectDate);
  
                                  const header =  ['Sr.No', 'EMPID', 'Empl Name','Date of joining','Location','Emp Status', ...formatedateColumns,'Present Days', 'Single Pay Hrs', 'Double Pay Hrs','Night shift count'];
                                 
  
                                  this.headerValues = header;
  
                                  const csvData = [
                                  header
                                  ];
                                  const dateRange = [];
  
                              
                                  for (let dt = new Date(selectDate); dt <= toselectDate; dt.setDate(dt.getDate() + 1)) {
                                      dateRange.push(dt.toISOString().split('T')[0]);
                                  }
                                  const employeeMap = {};
                                  let totalLoginTimeInSeconds = 0;
                                  let total_OvertimeTimeInSeconds = 0;
                                  // Process each record
                                  this.itemsdata.forEach(record => {
                                      const empKey = record.EMPID;
                                      
  
  
                                      if (!employeeMap[empKey]) {
                                          employeeMap[empKey] = { ...record };
  
                                          dateColumns.forEach((date, dateIndex) => {
                                              employeeMap[empKey][date] = '';
                                      });
                                          employeeMap[empKey].presentcount = 0; 
                                          employeeMap[empKey].singlepayhrs ='00:00:00';
                                          employeeMap[empKey].doublepayhrs = '00:00:00';
                                          employeeMap[empKey].nightshiftcount = 0;
                                      }
  
  
                                    
                                      employeeMap[empKey][record.adate] = record.attendancestatus;
  
  
                                      let samedaynightshiftovertime = 0;
                                      let filternightshift = record.filternightshift;
  
                                       if(record.overtimestart && record.overtimeend && filternightshift.length > 0){
                                        
                                          let  total_overtime =  this._getsumtwodates(record.overtimestart,record.overtimeend)
                                          let nightshiftovertime = filternightshift[0].totalshifthours
                                  
                                          if(total_overtime >= nightshiftovertime){
                                            samedaynightshiftovertime = 1
                                          }
                                        }
   
                                        let overtimehrs = '00:00:00'
                                      if(!record.totalbreakdurationinseconds && record.overtimedurationinseconds){
                                        overtimehrs = this._formatTime(record.overtimedurationinseconds)
                                      }
                                  
                                      if(record.totalbreakdurationinseconds && record.overtimedurationinseconds){
                                        let c = Number(record.overtimedurationinseconds) + Number(record.totalbreakdurationinseconds)
                                        overtimehrs= this._formatTime(c)
                                      }
  
                                      if (record.attendancestatus == 'P') {
                                        employeeMap[empKey].doublepayhrs = this._sumTimes( employeeMap[empKey].doublepayhrs,overtimehrs);
                                    }
                                        // if (record.overtimedurationinseconds) {
                                        //   const overtimeHours = this.secondsToHours(record.overtimedurationinseconds);
                                        //   employeeMap[empKey].doublepayhrs  += overtimeHours;
  
                                        // }
                                        
  
                                        let checknightshift = filternightshift.filter(i=>i.id == record.shiftdetailsid && i.premiseid == record.attendancepremiseid)
  
                                        if(record.attendance_status =='P' && record.checknightshift.length > 0){
                                          employeeMap[empKey].nightshiftcount++;
                                          }
  
                                        if(record.attendancestatus =='P' && filternightshift.length > 0 && samedaynightshiftovertime==1){
                                          employeeMap[empKey].nightshiftcount++;
                                          }
               
  
  
                                      
                                      if (record.attendancestatus === 'P') {
                                          employeeMap[empKey].presentcount++;
                                      } else if (record.attendancestatus === 'A') {
                                          employeeMap[empKey].upsentcount++;
                                      }
                                      if(record.attendancestatus === 'PA'  && employeeMap[empKey][record.adate])
                                      {
                                         employeeMap[empKey].singlepayhrs = this._sumTimes(employeeMap[empKey].singlepayhrs,record.total_login_time);


                                          // totalLoginTimeInSeconds += this.convertTimeToSeconds(record.total_login_time);
                                          // employeeMap[empKey].singlepayhrs = this.convertSecondsToTimeString(totalLoginTimeInSeconds);
                                      }
                                      // total_OvertimeTimeInSeconds += this.convertTimeToSeconds(record.Total_Overtime);
                                      //     employeeMap[empKey].doublepayhrs = this.convertSecondsToTimeString(total_OvertimeTimeInSeconds);
  
  
                                   if(record.attendancestatus =='P'  && checknightshift.length > 0)
                                      {
                                        employeeMap[empKey].nightshiftcount++;
                                      }
                                  
                                      if(record.attendancestatus =='P'  && filternightshift.length > 0 && samedaynightshiftovertime==1)
                                      {
                                        employeeMap[empKey].nightshiftcount++;
                                      }
  
  
  
                                  });
  
                                  const output = Object.values(employeeMap);
                                  this.finalOutput = output;
  
                              if(Object.keys(this.finalOutput).length)
                              {
                                this.norecordsfound = false;
                              }else{
                                this.norecordsfound = true;
                              }
                          const attendanceBody = document.getElementById('attendanceBody');
                      output.forEach((employee, index) => {
                              console.log("innnnnnn");
                              const row = document.createElement('tr');
  
                              // Create cell for Serial Number
                              const srNoCell = document.createElement('td');
                                  srNoCell.textContent = index + 1; // Serial number starts from 1
                                  row.appendChild(srNoCell);
                              
                              const empIdCell = document.createElement('td');
                              empIdCell.textContent = employee.EMPID;
                              row.appendChild(empIdCell);
  
                              const empNameCell = document.createElement('td');
                              empNameCell.textContent = employee.EMPLY_NAME;
                              row.appendChild(empNameCell);
  
                              const empjoiningdate = document.createElement('td');
                              empjoiningdate.textContent =  this.convertDateString(employee.joiningdate);;
                              row.appendChild(empjoiningdate);
  
                              const empLocationCell = document.createElement('td');
                              empLocationCell.textContent = employee.LOCATION;
                              row.appendChild(empLocationCell);
  
                              const empstatus = document.createElement('td');
                              empstatus.textContent = employee.EMP_STATUS;
                              row.appendChild(empstatus);
  
                          
                              dateColumns.forEach(dateKey => {
                                  const dateCell = document.createElement('td');
                                  dateCell.textContent = employee[dateKey] || ''; 
                                  row.appendChild(dateCell);
                              });
  
                              
                              const presentCountCell = document.createElement('td');
                              presentCountCell.textContent = employee.presentcount;
                              row.appendChild(presentCountCell);
  
                              const singlepayhrsCountCell = document.createElement('td');
                              singlepayhrsCountCell.textContent = employee.singlepayhrs;
                              row.appendChild(singlepayhrsCountCell);
  
                              const doublepayhrsCountCell = document.createElement('td');
                              doublepayhrsCountCell.textContent = employee.doublepayhrs;
                              row.appendChild(doublepayhrsCountCell);
  
                              const nightshiftcountCountCell = document.createElement('td');
                              nightshiftcountCountCell.textContent = employee.nightshiftcount;
                              row.appendChild(nightshiftcountCountCell);
                              
  
                              // if(attendanceBody)
                              attendanceBody.appendChild(row);
                          });
  
                              console.log("ouput list----------->",output);
                              
  
                        }else if(result.body.msg == "1" && this.hubItems.length == 1 && this.selectedhub != '' )
                        {
  
                                 this.totalcountflag = false;
                              
                                  const dateColumns = this.generateDateRangeColumns(selectDate, toselectDate);
                                  const formatedateColumns = this.generateDateFormateRangeColumns(selectDate, toselectDate);
  
  
                                 
  
                                  const header =  ['Sr.No', 'EMPID', 'Empl Name','Date of joining','Location','Emp Status', ...formatedateColumns,'Present Days', 'Single Pay Hrs', 'Double Pay Hrs','Night shift count'];
  
                                  this.headerValues = header;
  
                                  const csvData = [
                                  header
                                  ];
                                  const dateRange = [];
  
                              
                                  for (let dt = new Date(selectDate); dt <= toselectDate; dt.setDate(dt.getDate() + 1)) {
                                      dateRange.push(dt.toISOString().split('T')[0]);
                                  }
                                  const employeeMap = {};
                                  let totalLoginTimeInSeconds = 0;
                                  let total_OvertimeTimeInSeconds = 0;
                                  // Process each record
                                  this.itemsdata.forEach(record => {
                                      const empKey = record.EMPID;
                                      
                                      if (!employeeMap[empKey]) {
                                          employeeMap[empKey] = { ...record };
  
                                          dateColumns.forEach((date, dateIndex) => {
                                              employeeMap[empKey][date] = '';
                                      });
                                          employeeMap[empKey].presentcount = 0; 
                                          employeeMap[empKey].singlepayhrs = '00:00:00';
                                          employeeMap[empKey].doublepayhrs = '00:00:00';
                                          employeeMap[empKey].nightshiftcount = 0;
                                      }
                                  
                                      employeeMap[empKey][record.adate] = record.attendancestatus;
  
                                      let samedaynightshiftovertime = 0;
                                      let filternightshift = record.filternightshift;
  
                                       if(record.overtimestart && record.overtimeend && filternightshift.length > 0){
                                        
                                          let  total_overtime =  this._getsumtwodates(record.overtimestart,record.overtimeend)
                                          let nightshiftovertime = filternightshift[0].totalshifthours
                                  
                                          if(total_overtime >= nightshiftovertime){
                                            samedaynightshiftovertime = 1
                                          }
                                        }
  
                                        let overtimehrs = '00:00:00'
                                      if(!record.totalbreakdurationinseconds && record.overtimedurationinseconds){
                                        overtimehrs = _self._formatTime(record.overtimedurationinseconds)
                                      }
                                  
                                      if(record.totalbreakdurationinseconds && record.overtimedurationinseconds){
                                        let c = Number(record.overtimedurationinseconds) + Number(record.totalbreakdurationinseconds)
                                        overtimehrs= _self._formatTime(c)
                                      }
  
                                      if (record.attendancestatus == 'P') {
                                        
                                        employeeMap[empKey].doublepayhrs = _self._sumTimes( employeeMap[empKey].doublepayhrs,overtimehrs);
                                    }
  
  
                                        // if (record.overtimedurationinseconds) {
                                        //   const overtimeHours = this.secondsToHours(record.overtimedurationinseconds);
  
                                        //   console.log("overtimehourds -------->",overtimeHours);
                                        //   employeeMap[empKey].doublepayhrs  += overtimeHours;
  
                                        // }
                                        let checknightshift = filternightshift.filter(i=>i.id == record.shiftdetailsid && i.premiseid == record.attendancepremiseid)
  
                                        if(record.attendance_status =='P' && record.checknightshift.length > 0){
                                          employeeMap[empKey].nightshiftcount++;
                                          }
  
                                        if(record.attendancestatus =='P' && filternightshift.length > 0 && samedaynightshiftovertime==1){
                                          employeeMap[empKey].nightshiftcount++;
                                          }
  
                                      
                                      if (record.attendancestatus === 'P') {
                                          employeeMap[empKey].presentcount++;
                                      } else if (record.attendancestatus === 'A') {
                                          employeeMap[empKey].upsentcount++;
                                      }
                                      if(record.attendancestatus === 'PA'  && employeeMap[empKey][record.adate])
                                      {
                                         employeeMap[empKey].singlepayhrs = this._sumTimes(employeeMap[empKey].singlepayhrs,record.total_login_time);
                                      }
                                      // total_OvertimeTimeInSeconds += this.convertTimeToSeconds(record.Total_Overtime);
                                      //     employeeMap[empKey].doublepayhrs = this.convertSecondsToTimeString(total_OvertimeTimeInSeconds);
  
                                  });
  
                                  const output = Object.values(employeeMap);
                                  this.finalOutput = output;
  
                                  
                              //       dateColumns.forEach(date => {
                              //     const th = document.createElement('th');
                              //     const start = new Date(date);
                              //     th.textContent = this.formatDateFun(start);
                              //     attendanceTable.querySelector('thead tr').insertBefore(th, presentCountHeader);
                              // });
  
  
                          
                          output.forEach((employee, index) => {
                              const row = document.createElement('tr');
  
                              // Create cell for Serial Number
                              const srNoCell = document.createElement('td');
                                  srNoCell.textContent = index + 1; // Serial number starts from 1
                                  row.appendChild(srNoCell);
                              
                              const empIdCell = document.createElement('td');
                              empIdCell.textContent = employee.EMPID;
                              row.appendChild(empIdCell);
  
                              const empNameCell = document.createElement('td');
                              empNameCell.textContent = employee.EMPLY_NAME;
                              row.appendChild(empNameCell);
  
                              const empjoiningdate = document.createElement('td');
                              empjoiningdate.textContent =  this.convertDateString(employee.joiningdate);;
                              row.appendChild(empjoiningdate);
  
                              const empLocationCell = document.createElement('td');
                              empLocationCell.textContent = employee.LOCATION;
                              row.appendChild(empLocationCell);
  
                              const empstatus = document.createElement('td');
                              empstatus.textContent = employee.EMP_STATUS;
                              row.appendChild(empstatus);
  
                          
                              dateColumns.forEach(dateKey => {
                                  const dateCell = document.createElement('td');
                                  dateCell.textContent = employee[dateKey] || ''; 
                                  row.appendChild(dateCell);
                              });
  
                              
                              const presentCountCell = document.createElement('td');
                              presentCountCell.textContent = employee.presentcount;
                              row.appendChild(presentCountCell);
  
                              const singlepayhrsCountCell = document.createElement('td');
                              singlepayhrsCountCell.textContent = employee.singlepayhrs;
                              row.appendChild(singlepayhrsCountCell);
  
                              const doublepayhrsCountCell = document.createElement('td');
                              doublepayhrsCountCell.textContent = employee.doublepayhrs;
                              row.appendChild(doublepayhrsCountCell);
  
                              const nightshiftcountCountCell = document.createElement('td');
                              nightshiftcountCountCell.textContent = employee.nightshiftcount;
                              row.appendChild(nightshiftcountCountCell);
                              
  
                              if (attendanceBody) {
                              attendanceBody.appendChild(row);
                              }
                          });
  
                              console.log("ouput list----------->",output);
                              
  
                        }
                        else 
                        {
                        
                          this.finalOutput =[];
                          const formatedateColumns = this.generateDateFormateRangeColumns(selectDate, toselectDate);
  
                          const header = ['Sr.No', 'EMPID', 'Empl Name','Date of joining','Location','Emp Status', ...formatedateColumns,'Present Days', 'Single Pay Hrs', 'Double Pay Hrs','Night shift count'];
                          this.headerValues = header;
                          this.totalcountflag = true;
  
                          const attendanceBody = document.getElementById('attendanceBody');
                          const attendanceTable = document.getElementById('attendanceTable');
  
                          
                          // Clear all child elements (rows) from the tbody
                          while (attendanceBody.firstChild) {
                              attendanceBody.removeChild(attendanceBody.firstChild);
                          }
  
                          //const headerCells = attendanceTable.querySelectorAll('thead th');
                              const columnCount = header.length;
  
                              // Create and append the "No Records Found" row
                              const noRecordsRow = document.createElement('tr');
                              noRecordsRow.innerHTML = `<td colspan="${columnCount}" class="text-center">No Records Found</td>`; 
                              attendanceBody.appendChild(noRecordsRow);
  
                        this.$fire({
                                    text:"Record not found",
                                    type: "error",
                                    timer: 30000
                                }); 
                        // alert("Can not Download");
                        if(this.hubItems.length == 1 && this.selectedhub == '')
                              {
                                  this.$fire({
                                                  text:"Select Hub",
                                                  type: "error",
                                                  timer: 30000
                                              }); 
                                              return true;
                              }
                        }
                })
                .catch((ex) => {
                    console.log("error", ex);
                });
          
          },
   secondsToHours(seconds) {
    return seconds / 3600;
  },
  
  _sumTimes(time1, time2) {
    const [hours1, minutes1, seconds1] = time1.split(':').map(Number);
    const [hours2, minutes2, seconds2] = time2.split(':').map(Number);
  
    let totalSeconds = seconds1 + seconds2;
    let totalMinutes = minutes1 + minutes2 + Math.floor(totalSeconds / 60);
    let totalHours = hours1 + hours2 + Math.floor(totalMinutes / 60);
  
    totalSeconds %= 60;
    totalMinutes %= 60;
    totalHours %= 24;  // To keep it within 24-hour format.
  
    return `${String(totalHours).padStart(2, '0')}:${String(totalMinutes).padStart(2, '0')}:${String(totalSeconds).padStart(2, '0')}`;
  },
  _formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
  
      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(secs).padStart(2, '0');
  
      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  },
  
           convertDateString(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with 0 if needed
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed)
      const year = date.getFullYear(); // Get year
      return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
  },
  _getsumtwodates(date1, date2) {
      const timestamp1 = new Date(date1);
      const timestamp2 = new Date(date2);
      const differenceInMilliseconds = timestamp2 - timestamp1;
  
  
      const newDifferenceInMilliseconds = differenceInMilliseconds
  
      const newTotalSeconds = Math.floor(newDifferenceInMilliseconds / 1000);
  
      const newHours = Math.floor(newTotalSeconds / 3600);
      const newMinutes = Math.floor((newTotalSeconds % 3600) / 60);
      const newSeconds = newTotalSeconds % 60;
  
      const pad = num => String(num).padStart(2, '0');
  
      const newFormattedTimeDifference = `${pad(newHours)}:${pad(newMinutes)}:${pad(newSeconds)}`;
  
      return newFormattedTimeDifference
  },
   convertTimeToSeconds(timeString) {
      const parts = timeString.split(':');
      const hours = parseInt(parts[0]) || 0;
      const minutes = parseInt(parts[1]) || 0;
      const seconds = parseInt(parts[2]) || 0;
      return hours * 3600 + minutes * 60 + seconds;
  },
  
   convertSecondsToTimeString(totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  },
       ExportList : function () {
  
              var userdata = localStorage.getItem("userData");
              var userInfo = JSON.parse(userdata);
              
              var selectDate = (this.selectDate!=null)?this.formatDate(this.selectDate):"";
              var toselectDate = (this.toselectDate!=null)?this.formatDate(this.toselectDate):"";
    
              var warehouseid=(this.valueWH.length>0)? this.valueWH: [''];
              
              const csvObj = {
                  sysusermasterid:`${userInfo.sysusermasterid}`,
                  startdate : selectDate,
                  enddate : toselectDate,
                  selectedhub : `${this.selectedhub}`,
                  usertype:`${userInfo.user_type}`
              }
  
             // this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getHubWiseEmployeeReportDownload?sysusermasterid=${this.hubid}&usertype=${this.User_type}`
  
              this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getHubWiseEmployeeReportDownload?sysusermasterid=`+userInfo.sysusermasterid+`&startdate=`+selectDate+`&enddate=`+toselectDate+`&selectedhub=`+this.selectedhub+`&usertype=`+userInfo.user_type+` `;
   
              console.log(' this.loadur==================', this.loadurl)
     //console.log("this.loadurl",this.loadurl)
    
              // this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubWiseEmployeeReportDownload`,csvObj)
              //   .then(result =>{
              //     this.$fire({
              //                       text:"Record not found",
              //                       type: "error",
              //                       timer: 30000
              //                   }); 
              //     console.log("result--------->",result);
              //   })
              //   .catch((ex) => {
              //       console.log("error", ex);
              //   });
          
          },
      convertToObjects(data) {
              const headers = data[0];
              this.items = data.slice(1).map(row => {
                  const obj = {};
                  headers.forEach((header, index) => {
                  obj[header] = row[index] !== undefined ? row[index] : ""; // Handle missing values
                  });
                  return obj;
              });
          },
          generateDateRangeColumns(startDate, endDate) {
  
              // console.log('startDate=========>',startDate)
              // console.log('endDate==========>',endDate)
  
              const start = new Date(startDate);
              console.log('start==============>',start)
              const end = new Date(endDate);
              // if(start!=end){
              // end.setDate(end.getDate() + 1);
              // }
              console.log('end===========>',end)
              const dateArray = [];
  
              // Generate all dates between startDate and endDate
              while (start <= end) {
              //console.log('in======',start)
              const dateStr = this.formatDate(start); // Format as YYYY-MM-DD
              //console.log('dateStr=========>',dateStr)
              dateArray.push(dateStr);
              start.setDate(start.getDate() + 1); // Increment by one day
              //console.log('start====&==',start)
              }
  
              //console.log('dateArray===========>',dateArray)
              return dateArray;
          },
          generateDateFormateRangeColumns(startDate, endDate) {
  
                  // console.log('startDate=========>',startDate)
                  // console.log('endDate==========>',endDate)
  
                  const start = new Date(startDate);
                  console.log('start==============>',start)
                  const end = new Date(endDate);
  
                  console.log('end===========>',end)
                  const dateArray = [];
  
                  // Generate all dates between startDate and endDate
                  while (start <= end) {
                  console.log('in======',start)
                  const dateStr = this.formatDate(start); // Format as YYYY-MM-DD
                  console.log('dateStr=========>',dateStr)
                  dateArray.push(this.formatDateFun(start));
                  start.setDate(start.getDate() + 1); // Increment by one day
                  console.log('start====&==',start)
                  }
  
                  console.log('dateArray===========>',dateArray)
                  return dateArray;
          },
          formatDateFun(date) {
              if (!(date instanceof Date) || isNaN(date)) {
                  throw new Error('Invalid Date');
              }
  
              const day = String(date.getDate()).padStart(2, '0'); // Get day
              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
              const month = monthNames[date.getMonth()]; // Get month
              const year = String(date.getFullYear()).slice(-2);
  
              return `${day}-${month}-${year}`; // Return formatted date
          },
    
          showWHlist:function(){
            
              var userdata = localStorage.getItem('userData')
              var userInfo = JSON.parse(userdata)
              
              var csvObj = {
                  sysusermasterid:`${userInfo.sysusermasterid}`,
                  usertype:`${userInfo.user_type}`
              };
              this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubList`, csvObj)
                .then(result => {
                  
                  if (result.body.returnmsg === 'Successful') {
                      this.optionsWH=[];
                  
                      this.WHData  = result.body.returnvalue;
                      
                      for(let j = 0; j < this.WHData.length; j++) {
                          let WH = {
                          name: this.WHData[j].hub_title + " - " + this.WHData[j].fcclock_hubid,
                          id: this.WHData[j].fcclock_hubid,
                          }
                      this.optionsWH.push(WH);
                      }
                  
                  } else {              
                      this.WHData  = result.body.returnvalue;
                  }
    
              })
              .catch(ex => {
                  console.log("error-----", ex);
              });
          },
    
          formatDate: function(date) {
              var d = new Date(date),
                  month = "" + (d.getMonth() + 1),
                  day = "" + d.getDate(),
                  year = d.getFullYear();
              if (month.length < 2) month = "0" + month;
              if (day.length < 2) day = "0" + day;
              return [year, month, day].join("-");
    
          },
      },
    }
    </script>
    
    <style scoped>
     
    
    </style>